import { useEffect, useState } from "react";
import { getRuleDetail } from "../services/rulesService";

interface IuseFetchRule {
  setIsLoading: any;
  currentRuleId: any;
  isFromExecution?: boolean;
}
const useFetchRuleById = ({
  setIsLoading,
  currentRuleId,
  isFromExecution,
}: IuseFetchRule) => {
  const [ruleData, setRuleData] = useState<any>({});
  useEffect(() => {
    setIsLoading(true);
    if (currentRuleId && currentRuleId > 0 && !isFromExecution) {
      const getRuleData = async () => {
        try {
          const result = await getRuleDetail(currentRuleId);
          setRuleData(result);
        } catch (err) {
          setRuleData([]);
        } finally {
          setIsLoading(false);
        }
      };

      getRuleData();
    }
  }, [currentRuleId]);

  return [ruleData];
};

export default useFetchRuleById;
